import { EnvironmentUrl } from './environment-url';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceRequestBase } from '../../_interfaces/ServiceRequestBase';

export class BaseCRUDService {
  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
    private service: string,
  ) {}

  public list = () => {
    return this.http.get<ServiceRequestBase[]>(
      this.createCompleteRoute('api/' + this.service + '/List'),
    );
  };

  public get = (id: any) => {
    return this.http.get<ServiceRequestBase>(
      this.createCompleteRoute('api/' + this.service + '/Get?id=' + id),
    );
  };

  public create = (serviceRequest: ServiceRequestBase) => {
    return this.http.post<ServiceRequestBase>(
      this.createCompleteRoute('api/' + this.service + '/Create'),
      serviceRequest,
      this.generateHeaders(),
    );
  };

  public update = (id: any, serviceRequest: ServiceRequestBase) => {
    return this.http.put<ServiceRequestBase>(
      this.createCompleteRoute('api/' + this.service + '/Update?id=' + id),
      serviceRequest,
      this.generateHeaders(),
    );
  };

  public delete = (id: any) => {
    return this.http.delete<ServiceRequestBase>(
      this.createCompleteRoute('api/' + this.service + '/Delete?id=' + id),
      this.generateHeaders(),
    );
  };

  private createCompleteRoute = (route: string) => {
    return `${this.envUrl.urlAddress}/${route}`;
  };

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
  };
}
